import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class HardwareService {
  isMobile(): boolean {
    if (Capacitor.isNativePlatform()) return true;
    const data = (navigator as Navigator & { userAgentData?: { mobile: boolean } }).userAgentData;
    if (data?.mobile) return true;
    if (/Android|iPhone|iPad|iPod|IEMobile|Windows Phone/i.test(navigator.userAgent)) return true;
    // iPad desktop user agent; touch-enabled Windows laptops remain desktop.
    return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
  }
}
